/**
 * Тонкая обёртка над fetch к нашему API.
 *
 * На dev'е Vite-proxy перенаправляет /api на localhost:3000, на prod'е
 * фронт раздаётся с того же origin'а, что и API — пути без изменений.
 */

export interface Me {
    user: {
        name:  string | null;
        email: string | null;
        image: string | null;
    } | null;
    /** Сервер фиксирует на основе users.role (см. users-storage.ts). */
    isAdmin?: boolean;
}

export async function fetchMe(): Promise<Me> {
    const res = await fetch('/api/me', { credentials: 'include' });
    if (!res.ok) throw new Error(`/api/me failed: ${res.status}`);
    return res.json() as Promise<Me>;
}

async function getCsrfToken(): Promise<string> {
    const res = await fetch('/api/auth/csrf', { credentials: 'include' });
    const { csrfToken } = await res.json() as { csrfToken: string };
    return csrfToken;
}

/**
 * Запускает GitHub OAuth — Auth.js v5 требует POST на /api/auth/signin/github
 * с CSRF-токеном. Делаем это через скрытую form, чтобы браузер сам прошёл
 * через 302-редирект на github.com (fetch не может из-за CORS).
 */
export async function signInWithGitHub(callbackUrl = '/'): Promise<void> {
    const csrfToken = await getCsrfToken();
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/api/auth/signin/github';
    form.style.display = 'none';

    const csrfInput = document.createElement('input');
    csrfInput.name  = 'csrfToken';
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);

    const cbInput = document.createElement('input');
    cbInput.name  = 'callbackUrl';
    cbInput.value = callbackUrl;
    form.appendChild(cbInput);

    document.body.appendChild(form);
    form.submit();
}

export async function signOut(): Promise<void> {
    const csrfToken = await getCsrfToken();
    await fetch('/api/auth/signout', {
        method:      'POST',
        credentials: 'include',
        headers:     { 'Content-Type': 'application/x-www-form-urlencoded' },
        body:        `csrfToken=${encodeURIComponent(csrfToken)}`,
    });
}
